import {
  Batch,
  BatchRepository,
  BatchId,
  BatchType,
  BatchLocation,
  BatchMount,
  BatchOwner,
  BatchCounty,
  BatchSurface,
  BatchEconomicInfo,
  BatchWindow,
  BatchCertifications,
  BatchCertificationFlag,
  BatchSituation,
  BatchPurpose,
  BatchIntervention,
  BatchAlreadyWithOfferFlag
} from '@/Domain/Batch'
import { Currency } from '@/Domain/Batch/Currency'
import {
  Species,
  SpeciesBinomen,
  SpeciesFootNumber,
  SpeciesVolume,
  SpeciesUnitCost,
  SpeciesObservations,
  SpeciesTarget
} from '@/Domain/Batch/Species'
import { ProcedureId } from '@/Domain/Procedures'
import { AccountId } from '@/Domain/Account'

async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}
const getBatches = (): Batch[] => {
  const acaciaResultas = new Species(
    1,
    new SpeciesBinomen('Acacia sp.'),
    null,
    new SpeciesVolume(1230.65),
    1,
    null,
    new SpeciesTarget(SpeciesUnitCost.fromString('35,56'), SpeciesVolume.fromString('1.543,23')),
    new SpeciesTarget(SpeciesUnitCost.fromString('53,56'), SpeciesVolume.fromString('3.987,23')),
    new SpeciesTarget(SpeciesUnitCost.fromString('35,01'), SpeciesVolume.fromString('2.123,23')),
    null
  )
  const pinusResultas = new Species(
    2,
    new SpeciesBinomen('Pinus radiata'),
    null,
    new SpeciesVolume(1230.65),
    2,
    null,
    new SpeciesTarget(SpeciesUnitCost.fromString('22,56'), SpeciesVolume.fromString('1.888,23')),
    null,
    new SpeciesTarget(SpeciesUnitCost.fromString('66,01'), SpeciesVolume.fromString('2.999,23')),
    null
  )
  const eucalyptusResultas = new Species(
    3,
    new SpeciesBinomen('Eucalyptus sp.'),
    null,
    new SpeciesVolume(1230.65),
    3,
    null,
    null,
    new SpeciesTarget(SpeciesUnitCost.fromString('35,56'), SpeciesVolume.fromString('5.543,23')),
    new SpeciesTarget(SpeciesUnitCost.fromString('35,01'), SpeciesVolume.fromString('9.123,23')),
    null
  )
  const acacia = new Species(
    4,
    new SpeciesBinomen('Acacia sp.'),
    new SpeciesFootNumber(54.54),
    new SpeciesVolume(1230.65),
    4,
    new SpeciesUnitCost(122.00),
    null,
    null,
    null,
    null
  )
  const eucalyptus = new Species(
    5,
    new SpeciesBinomen('Eucalyptus globulus'),
    new SpeciesFootNumber(12.54),
    new SpeciesVolume(123.65),
    5,
    new SpeciesUnitCost(12.00),
    null,
    null,
    null,
    new SpeciesObservations('AUG')
  )
  return [
    new Batch(
      new BatchId('019/20', '360076510001'),
      BatchType.RISCO,
      new BatchCertifications(
        BatchCertificationFlag.isTrue(),
        BatchCertificationFlag.isFalse()
      ),
      new BatchLocation(
        new BatchMount('Hío'),
        new BatchOwner('Hío'),
        new BatchCounty('Cangas')
      ),
      new BatchIntervention(
        BatchPurpose.TURN,
        BatchSituation.STANDING
      ),
      new BatchSurface(100),
      new BatchEconomicInfo(
        new Currency(9317.69),
        new Currency(173.83),
        new Currency(186.35)
      ),
      new BatchWindow(6),
      'm3',
      BatchAlreadyWithOfferFlag.isTrue(),
      [eucalyptus, acacia]
    ),
    new Batch(
      new BatchId('019/19', '360088910001'),
      BatchType.RISCO,
      new BatchCertifications(
        BatchCertificationFlag.isTrue(),
        BatchCertificationFlag.isFalse()
      ),
      new BatchLocation(
        new BatchMount('Hío'),
        new BatchOwner('Hío'),
        new BatchCounty('Cangas')
      ),
      new BatchIntervention(
        BatchPurpose.TURN,
        BatchSituation.STANDING
      ),
      new BatchSurface(100),
      new BatchEconomicInfo(
        new Currency(9317.69),
        new Currency(173.83),
        new Currency(186.35)
      ),
      new BatchWindow(6),
      'm3',
      BatchAlreadyWithOfferFlag.isFalse(),
      [acacia]
    ),
    new Batch(
      new BatchId('019/22', '360088910001'),
      BatchType.RISCO,
      new BatchCertifications(
        BatchCertificationFlag.isTrue(),
        BatchCertificationFlag.isFalse()
      ),
      new BatchLocation(
        new BatchMount('Hío'),
        new BatchOwner('Hío'),
        new BatchCounty('Cangas')
      ),
      new BatchIntervention(
        BatchPurpose.TURN,
        BatchSituation.STANDING
      ),
      new BatchSurface(100),
      new BatchEconomicInfo(
        new Currency(9317.69),
        new Currency(173.83),
        new Currency(186.35)
      ),
      new BatchWindow(6),
      'm3',
      BatchAlreadyWithOfferFlag.isFalse(),
      [acacia]
    ),
    new Batch(
      new BatchId('019/21', '360091910001'),
      BatchType.RESULTAS,
      new BatchCertifications(
        BatchCertificationFlag.isTrue(),
        BatchCertificationFlag.isFalse()
      ),
      new BatchLocation(
        new BatchMount('Mos'),
        new BatchOwner('Mos'),
        new BatchCounty('Mos')
      ),
      new BatchIntervention(
        BatchPurpose.TURN,
        BatchSituation.STANDING
      ),
      new BatchSurface(53.34),
      new BatchEconomicInfo(
        new Currency(19317.69),
        new Currency(1173.83),
        new Currency(1186.35)
      ),
      new BatchWindow(12),
      'm3',
      BatchAlreadyWithOfferFlag.isFalse(),
      [acaciaResultas, eucalyptusResultas, pinusResultas]
    ),
    new Batch(
      new BatchId('019/23', '360091910001'),
      BatchType.RESULTAS,
      new BatchCertifications(
        BatchCertificationFlag.isTrue(),
        BatchCertificationFlag.isFalse()
      ),
      new BatchLocation(
        new BatchMount('Mos'),
        new BatchOwner('Mos'),
        new BatchCounty('Mos')
      ),
      new BatchIntervention(
        BatchPurpose.TURN,
        BatchSituation.STANDING
      ),
      new BatchSurface(53.34),
      new BatchEconomicInfo(
        new Currency(19317.69),
        new Currency(1173.83),
        new Currency(1186.35)
      ),
      new BatchWindow(12),
      'm3',
      BatchAlreadyWithOfferFlag.isFalse(),
      [acaciaResultas, eucalyptusResultas, pinusResultas]
    )
  ]
}

export class InMemoryBatchRepository implements BatchRepository {
  // eslint-disable-next-line
  async byProcedureId (procedureId: ProcedureId): Promise<Batch[]> {
    const duration = 1000
    await wait(duration)
    return getBatches()
  }

  // eslint-disable-next-line
  async byProcedureIdAndUserIdWithOffers (procedureId: ProcedureId, accountId: AccountId): Promise<Batch[]> {
    const duration = 1000
    await wait(duration)
    return getBatches()
  }
}
